var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Registration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3C9.144531 3 6 6.144531 6 10C6 12.410156 7.230469 14.550781 9.09375 15.8125C5.527344 17.34375 3 20.882813 3 25L5 25C5 20.570313 8.570313 17 13 17C15.144531 17 17.0625 17.878906 18.5 19.25L13.78125 23.96875L13.71875 24.28125L13.03125 27.8125L12.71875 29.28125L14.1875 28.96875L17.71875 28.28125L18.03125 28.21875L28.125 18.125C29.285156 16.964844 29.285156 15.035156 28.125 13.875C27.542969 13.292969 26.769531 13 26 13C25.246094 13 24.484375 13.285156 23.90625 13.84375L19.9375 17.8125C19.066406 16.976563 18.035156 16.292969 16.90625 15.8125C18.769531 14.550781 20 12.410156 20 10C20 6.144531 16.855469 3 13 3 Z M 13 5C15.773438 5 18 7.226563 18 10C18 12.773438 15.773438 15 13 15C10.226563 15 8 12.773438 8 10C8 7.226563 10.226563 5 13 5 Z M 26 15C26.253906 15 26.519531 15.082031 26.71875 15.28125C27.117188 15.679688 27.117188 16.289063 26.71875 16.6875L17.03125 26.375L15.25 26.75L15.625 24.96875L25.3125 15.28125C25.511719 15.082031 25.746094 15 26 15Z",
    fill: "#26260D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Registration);
export default __webpack_public_path__ + "static/media/icons8_registration.c43f9b98d6ca7c234c7460d4c7db5dfc.svg";
export { ForwardRef as ReactComponent };